import recentSearches from '../utils/storage/recentSearches';

export const FETCH_SEARCH = 'FETCH_SEARCH';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const FETCH_PREPOPULATE_SEARCH = 'FETCH_PREPOPULATE_SEARCH';
export const ADD_RECENT_SEARCH = 'ADD_RECENT_SEARCH';
export const GET_RECENT_SEARCHES = 'GET_RECENT_SEARCHES';
export const REMOVE_RECENT_SEARCH = 'REMOVE_RECENT_SEARCH';
export const CLEAR_RECENT_SEARCHES = 'CLEAR_RECENT_SEARCHES';

export const searchResultsContentId = 'searchResults';

function fetchSearchEffect(type, params, disableLoadingState = false) {
  return {
    type,
    api: {
      endpoint: ['ui', 'search'],
      args: [{ ...params, isPrepopulateSearch: type === FETCH_PREPOPULATE_SEARCH }],
    },
    meta: {
      contentId: searchResultsContentId,
      disableLoadingState,
      searchTerm: params.query,
    },
  };
}

export function performSearch(params, disableLoadingState) {
  return fetchSearchEffect(FETCH_SEARCH, params, disableLoadingState);
}

export function performPrepopulateSearch(params) {
  return fetchSearchEffect(FETCH_PREPOPULATE_SEARCH, params);
}

export function addRecentSearch(term) {
  return { type: ADD_RECENT_SEARCH, recentSearches: recentSearches.add(term) };
}

export function getRecentSearches() {
  return { type: GET_RECENT_SEARCHES, recentSearches: recentSearches.get() };
}

export function removeRecentSearch(termIndex) {
  return {
    type: REMOVE_RECENT_SEARCH,
    recentSearches: recentSearches.remove(termIndex),
  };
}

export function clearRecentSearches() {
  return {
    type: CLEAR_RECENT_SEARCHES,
    recentSearches: recentSearches.clear(),
  };
}

export function clearSearch() {
  return {
    type: CLEAR_SEARCH,
  };
}
